import { isApplicationNonProd } from 'Utilities/helpers';

import dealerRatingsCohort from './DealerRatingsExperimentCohort.json';

type GetBidPositionParams = {
  closingBidValue?: number | null;
  prepCosts?: number | null;
  priceHigh?: number | null;
  sellerWillAcceptPrice?: number | null;
};

export const getIsDealerInCohort = (dealerId?: number): boolean => {
  const cohortToUse = isApplicationNonProd ? 'stage' : 'production';
  return dealerId !== undefined && dealerRatingsCohort[cohortToUse].some((dealer) => dealer.dealerId === dealerId);
};

export const getIsReservePriceMet = ({
  closingBidValue,
  prepCosts,
  priceHigh,
  sellerWillAcceptPrice,
}: GetBidPositionParams): boolean => {
  if (!priceHigh || !closingBidValue) {
    return false;
  }

  const reservePrice = sellerWillAcceptPrice ?? priceHigh - (prepCosts ?? 0);

  return closingBidValue >= reservePrice;
};
